<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid mb-5">
          <div class="field">
            <label class="font-medium required-field">Объект</label>
            <crm-single-select
              [options]="kinds"
              [(selectedItem)]="delegation.kind"
              [isTemplateCombined]="true"
              [filter]="false"
              optionValue="name"
              [class]="errors?.kind ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.kind ? 'ng-invalid ng-dirty' : ''">
              <ng-template
                #itemTemplate
                let-kind="item">
                {{ kind.value | userDelegationTargetKindName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.kind"
              class="p-error">
              {{ errors.kind | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип участника</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="delegation.type"
              [isTemplateCombined]="true"
              [filter]="false"
              optionValue="name"
              [class]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | userDelegationTargetTypeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Назначить</label>
            <crm-user-single-select
              [(selectedUser)]="toUser"
              [isError]="$any(errors?.toUser)"
              appendTo="body"></crm-user-single-select>
            <small
              *ngIf="errors?.toUser"
              class="p-error">
              {{ errors.toUser | join }}
            </small>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="delegation.active"
              [binary]="true"
              inputId="active"></p-checkbox>
            <label [for]="'active'">Передавать новые объекты</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveDelegation()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteDelegation()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
